import { HTMLProps } from '@/lib/util/types';
import clsx from 'clsx';
import React, { PropsWithChildren, ReactNode } from 'react';
import Divider from '../Divider';
import styles from './List.module.scss';

export type ListProps = {
  separator?: boolean | ReactNode;
} & HTMLProps<HTMLUListElement>;

export default function List({
  children,
  separator,
  className,
  ...props
}: PropsWithChildren<ListProps>) {
  const separatorElement = separator === true ? <Divider /> : separator;
  const childCount = React.Children.count(children);

  return (
    <ul className={clsx(styles.list, className)} {...props}>
      {React.Children.map(children, (child, idx) => (
        <>
          {child}
          {idx < childCount - 1 && separatorElement}
        </>
      ))}
    </ul>
  );
}
